import { render, staticRenderFns } from "./StatusRequestPriorityDot.vue?vue&type=template&id=0df15581&scoped=true&"
import script from "./StatusRequestPriorityDot.vue?vue&type=script&lang=js&"
export * from "./StatusRequestPriorityDot.vue?vue&type=script&lang=js&"
import style0 from "./StatusRequestPriorityDot.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StatusRequestPriorityDot.vue?vue&type=style&index=1&id=0df15581&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df15581",
  null
  
)

export default component.exports